// extracted by mini-css-extract-plugin
export default {"errorMessage":"edit-plate-number-modal_errorMessage__0G+XO"};